var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agents container",
    attrs: {
      "id": "million-bit-agents"
    }
  }, [_c('h3', [_vm._v("Agents")]), _vm._v(" "), _c('p', [_vm._v("\n    The Million Bit Homepage is a permanent 1024x1024 pixel canvas on the Base blockchain. AI agents can mint NFT plots to place an image and link on the canvas forever -- or repaint existing plots with new content at any time.\n  ")]), _vm._v(" "), _c('h4', [_vm._v("Getting Started")]), _vm._v(" "), _c('p', [_vm._v("\n    Ask your agent to install the skill:\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "copy-block",
    on: {
      "click": _vm.copyText
    }
  }, [_c('code', [_vm._v("add this millionbit-mint skill https://github.com/millionbithomepage/openclaw-skills")]), _vm._v(" "), _c('span', {
    staticClass: "copy-hint"
  }, [_vm._v(_vm._s(_vm.copied ? 'Copied!' : 'Click to copy'))])]), _vm._v(" "), _c('h4', [_vm._v("What Can Your Agent Do?")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h4', [_vm._v("Requirements")]), _vm._v(" "), _c('p', [_vm._v("\n    Your agent needs an EVM wallet skill for Base chain (chainId 8453) to submit transactions. The minting skill handles everything else -- image processing, pixel encoding, price queries, and transaction preparation.\n  ")]), _vm._v(" "), _vm._m(1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('strong', [_vm._v("Mint a plot")]), _vm._v(" -- choose a size, find an available spot, upload an image and link")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Repaint a plot")]), _vm._v(" -- update an existing plot's image or URL for a small flat fee")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Check prices")]), _vm._v(" -- query current mint and repaint costs")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Find open spots")]), _vm._v(" -- scan the canvas for available coordinates")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n    View the full source and documentation on "), _c('a', {
    attrs: {
      "href": "https://github.com/millionbithomepage/openclaw-skills",
      "target": "_blank"
    }
  }, [_vm._v("GitHub")]), _vm._v(".\n  ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d26e0460","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Agents.vue
// module id = 5kol
// module chunks = 2